import { Component, inject } from '@angular/core';
import { DownloadAppButtonsComponent } from '../../../shared/components/download-app-buttons/download-app-buttons.component';
import { NgOptimizedImage } from '@angular/common';
import { Store } from '@ngxs/store';
import { UpdatedSideGraphic } from '../../../store/onboarding/onboarding.actions';
import { ProgressBarService } from '../../../_services/progress-bar-service/progress-bar.service';

@Component({
  selector: 'app-update-error',
  imports: [NgOptimizedImage, DownloadAppButtonsComponent],
  templateUrl: './update-error.component.html',
})
export class UpdateErrorComponent {
  readonly store = inject(Store);
  protected progressBarService = inject(ProgressBarService);

  constructor() {
    this.store.dispatch(new UpdatedSideGraphic('reg8_error.svg'));
    this.progressBarService.setHideProgress(true);
  }
}
